import {useCallback} from 'react';
import Image from 'next/image';

import {Button, Typography, usePopUpContext} from '@kasta-io/components';

export const useWelcomeReferredDialog = () => {
  const {setPopUp, hidePopUp} = usePopUpContext();

  const handleCashModalOpen = useCallback(() => {
    setPopUp({
      title: 'You have been referred by a friend',
      hasCloseButton: true,
      closeButtonType: 'primary-icon',
      headerImage: (
        <Image
          src="images/refer-a-friend.png"
          width={0}
          height={0}
          alt="Cash explainer assets image"
          unoptimized
        />
      ),
      children: (
        <Typography variant="subtitle1" color="var(--colors-text-onBackgroundMedium)">
          Create an account and share your referral link. Invite friends and earn rewards when they complete
          transactions.
        </Typography>
      ),
      footer: (
        <Button block onClick={hidePopUp}>
          Sign up
        </Button>
      ),
    });
  }, [hidePopUp, setPopUp]);

  return handleCashModalOpen;
};
